import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Swiper from "swiper";
import { Autoplay, Navigation, Pagination, FreeMode } from "swiper/modules";

/* Home swiper*/
document.querySelectorAll<HTMLDivElement>(".hero-swiper").forEach((container) => {
    new Swiper(container, {
        modules: [Pagination, Autoplay, Navigation],
        loop: false,
        pagination: { el: ".swiper-pagination", type: "fraction" },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});

const projectsContainers = <NodeListOf<HTMLElement>>document.querySelectorAll(".projects-section");

projectsContainers.forEach((container) => {
    let scrollActive = false;
    const swiperContainer = <HTMLElement>container.querySelector(".projects-swiper");
    const projectsSwiper = new Swiper(swiperContainer, {
        modules: [Autoplay, FreeMode],
        direction: "horizontal",
        loop: false,
        breakpoints: {
            640: {
                slidesPerView: 1,
                centeredSlides: true,
                freeMode: { enabled: false },
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
                freeMode: { enabled: true, sticky: false, momentum: false },
            },
        },
        spaceBetween: 32,
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
        },
    });

    const autoTranslate = () => {
        const rect = container.querySelector(".swiper-wrapper").getBoundingClientRect();
        const slides = container.querySelectorAll(".swiper-slide");
        // if already scrolled left on page load we need the distance between the first slide and the last
        const firstRect = slides[0].getBoundingClientRect();
        const lastRect = slides[slides.length - 1].getBoundingClientRect();
        const maxTranslate = Math.abs(lastRect.right - firstRect.left - rect.width);
        const wrapper = container.querySelector(".swiper-wrapper").getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const bottom = wrapper.bottom + windowHeight * 0.1;
        const currentTranslate = projectsSwiper.getTranslate();
        const topBorder = bottom + wrapper.height;

        if (topBorder < windowHeight) {
            projectsSwiper.translateTo(maxTranslate * -1, 250, true, true);
        } else if (bottom > windowHeight && currentTranslate !== 0) {
            projectsSwiper.translateTo(0, 250, true, true);
        } else if (topBorder >= windowHeight && bottom <= windowHeight) {
            const delta = bottom - windowHeight;
            const percentage = delta / wrapper.height;
            projectsSwiper.translateTo(maxTranslate * percentage, 250, true, true);
        }
    };

    const addScrollListener = () => {
        if (projectsSwiper) {
            projectsSwiper.autoplay.stop();
            scrollActive = true;
            window.addEventListener("scroll", autoTranslate);
        }
    };

    // translate on scroll should only be active for laptops and desktops
    if (!scrollActive && window.innerWidth >= 992) {
        addScrollListener();
    }

    window.addEventListener("resize", () => {
        if (!scrollActive && window.innerWidth >= 992) {
            addScrollListener();
        }
        if (scrollActive && window.innerWidth < 992) {
            scrollActive = false;
            projectsSwiper.autoplay.start();
            window.removeEventListener("scroll", autoTranslate);
        }
    });
});

/* Members swiper - todo: refactor in separate ts file? */
document.querySelectorAll<HTMLDivElement>(".members-swiper").forEach((container) => {
    new Swiper(container, {
        modules: [Navigation],
        loop: true,
        spaceBetween: 35,
        navigation: {
            nextEl: ".members-swiper__button--next",
            prevEl: ".members-swiper__button--prev",
        },
    });
});
